/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//German (Germany)
export default {
  'goal-actions.archive-goal.generic-error-title': 'Ziel konnte nicht archiviert werden',
  'goal-actions.copy-goal.cancel': 'Abbrechen',
  'goal-actions.copy-goal.close-modal': 'Fenster schließen',
  'goal-actions.copy-goal.error': 'Geben Sie Ihrem Ziel einen Namen, damit jeder weiß, worum es geht.',
  'goal-actions.copy-goal.failed-description':
    'Beim Klonen des Ziels ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.',
  'goal-actions.copy-goal.failed-description-forbidden': 'Sie sind nicht berechtigt, dieses Ziel zu kopieren.',
  'goal-actions.copy-goal.failed-title': 'Dieses Ziel konnte nicht geklont werden',
  'goal-actions.copy-goal.followers': 'Follower',
  'goal-actions.copy-goal.goal-name': 'Zielname',
  'goal-actions.copy-goal.include': 'Einbeziehen',
  'goal-actions.copy-goal.links': 'Links',
  'goal-actions.copy-goal.submit': 'Senden',
  'goal-actions.copy-goal.success-description': 'Das Ziel wurde erfolgreich geklont.',
  'goal-actions.copy-goal.success-link': 'Zeigen Sie das geklonte Ziel an.',
  'goal-actions.copy-goal.success-title': 'Das Ziel {goalName} wurde geklont',
  'goal-actions.copy-goal.title': 'Ziel kopieren',
  'goal-actions.follow-goal.follow-error-title': 'Dem Ziel konnte nicht gefolgt werden',
  'goal-actions.follow-goal.unfollow-error-title': 'Dem Ziel konnte nicht entfolgt werden',
  'goal-actions.goal-actions.archive-error-title': 'Ziel konnte nicht wiederhergestellt werden',
  'goal-actions.goal-actions.archive-goal': 'Ziel archivieren',
  'goal-actions.goal-actions.archive-restore-error-description':
    'Die Zieländerungen konnten nicht gespeichert werden. Bitte versuchen Sie es später erneut.',
  'goal-actions.goal-actions.copy-goal': 'Ziel kopieren',
  'goal-actions.goal-actions.copy-link': 'Link kopieren',
  'goal-actions.goal-actions.follow': 'Folgen',
  'goal-actions.goal-actions.generic-error-description':
    'Etwas ist schiefgelaufen. Versuchen Sie es in ein paar Minuten erneut.',
  'goal-actions.goal-actions.restore-goal': 'Ziel wiederherstellen',
  'goal-actions.goal-actions.share': 'Teilen',
  'goal-actions.goal-actions.show-more': 'Mehr anzeigen',
  'goal-actions.goal-actions.unfollow': 'Nicht mehr folgen',
  'goal-actions.goal-content.follow-confirmation-description':
    'Wir senden Ihnen in jeder ersten Woche des nächsten Monats eine Zusammenfassung mit den Updates zu allen Ziele, denen Sie folgen.',
  'goal-actions.goal-content.follow-confirmation-title': '🙌🏼 Sie folgen jetzt diesem Ziel!',
  'goal-actions.restore-goal.generic-error-title': 'Ziel konnte nicht wiederhergestellt werden',
};
